/**
 * @hidden
 * @ignore
 */
export function mapIfArray(a, fn) {
  return Array.isArray(a) ? a.map(fn) : a;
}